import { Alert, ConfigProvider, theme } from 'antd';
import { useEffect, Suspense, lazy } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import WhatsAppFloat from './comps/whatsappFloat/main';
import WorkspaceGuard from './comps/WorkspaceGuard';
import { trackPageView } from './funcs/metaPixel';
import getActiveUserId from './funcs/getActiveUserId';
import Loading from './comps/Loading';
import './App.css';
import './index.css';


const Home = lazy(() => import('./pages/home/main'));
const HomeV2 = lazy(() => import('./pages/homev2/main'));
const Automations = lazy(() => import('./pages/automate/main'));
const Signup = lazy(() => import('./pages/login/main'));
const InstaAccounts = lazy(() => import('./pages/instaAccounts/main'));
const SignupTwo = lazy(() => import('./pages/signup/main'));
const Oia = lazy(() => import('./pages/oia/main'));

const FbRdr = lazy(() => import('./pages/fb-redirect/main'));
const FbAPIRdr = lazy(() => import('./pages/fb-api-redirect/main'));
const ResetPassword = lazy(() => import('./pages/reset-password/main'));
const YT = lazy(() => import('./pages/yt-automation/main'));
const InboxAutomation = lazy(() => import('./pages/inbox-automation/main'));
const LinkExtract = lazy(() => import('./pages/linkExtract/main'));
// import Shop from './pages/shop/main';
const CollectMoney = lazy(() => import('./pages/collect-amount/main'));
const FlowComp = lazy(() => import('./pages/flow-automte/main'));
const AutomationList = lazy(() => import('./pages/automationList/main'));
const QuickDM = lazy(() => import('./pages/quick-dm/main'));

const RefferalList = lazy(() => import('./pages/referal_board/main'));
const LinkedIn = lazy(() => import('./pages/linkedin/main'));

const SellMain = lazy(() => import('./sell_pages/main/main'));
const Courses = lazy(() => import('./pages/courses/main'));
const CoursePurchaseFlow = lazy(() => import('./pages/course_client_side/main'));
const IDMDashboard = lazy(() => import('./pages/dashboard/main'));
const DigitalProducts = lazy(() => import('./pages/digital-products/main'));
const DigitalPurchaseFlow = lazy(() => import('./pages/digital_product_client_side/main'));
const Shopify = lazy(() => import('./pages/shopify/main'));
const SPConnectAPP = lazy(() => import('./pages/shopify-connect-app/main'));
const SPRDR = lazy(() => import('./pages/shopify-redirect/main'));
const SPLOGIN = lazy(() => import('./pages/shopify-login/main'));
const IGAUTHAPP = lazy(() => import('./pages/ig-auth-app/main'));

const FBHome = lazy(() => import('./pages/fb-home/main'));
const MessengerPage = lazy(() => import('./pages/messagner/main'));
const InstagramPostUploader = lazy(() => import('./pages/later/mani'));
const WelcomeOnboardingPage = lazy(() => import('./pages/welcome/main'));
const CollabInvite = lazy(() => import('./pages/collab-invite/main'));
const StripeSuccess = lazy(() => import('./pages/stripe-success/main'));
const StripeFailure = lazy(() => import('./pages/stripe-failure/main'));
const NotFound = lazy(() => import('./pages/not-found/main'));
const NotFoundPage = lazy(() => import('./pages/not-found/main'));
const SharedFlowPage = lazy(() => import('./pages/shared-flow/main'));
const TeamInvite = lazy(() => import('./pages/team-invite/main'));
const WorkspacePicker = lazy(() => import('./pages/workspace-picker/main'));
const ApiIntegration = lazy(() => import('./pages/make-integration/main'));
const TeamSettings = lazy(() => import('./pages/team-settings/main'));




const getDomainConfig = () => {
  const hostname = window.location.hostname;

  switch (hostname) {
    case "app.instantdm.com":
      return {
        button: { style: { borderRadius: 4, background: "#1677ff", color: "#fff" } },
        input: { style: { borderRadius: 4 } },
        modal: { style: { borderRadius: 4 } }
      };

    case "localhost":
      return {
        theme: {
          "token": {
            "wireframe": false,
            "colorPrimary": "#000000",
            "colorInfo": "#000000",
            "colorSuccess": "#2588e4"
          },
          "components": {

            Tag: {

              defaultBg: "#f0f0f0",             // background of default tag
              defaultColor: "#000000",          // text color of default tag

            }
          }
        },
        button: { style: { borderRadius: 0, background: "black", color: "#fff" } },
        input: { style: { borderRadius: 12 } },
        modal: { style: { borderRadius: 12 } },
        radio: {
          colorPrimary: "#ff4d4f", // radio checked color
          algorithm: true
        },



      };

    default:
      return {
        button: { style: { borderRadius: 4 } },
        input: { style: { borderRadius: 4 } },
        modal: { style: { borderRadius: 4 } }
      };
  }
};





function App() {
  const config = getDomainConfig();
  const location = useLocation();

  // Track page views on route changes for Meta Pixel
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  useEffect(() => {

    try {
      let user_id = getActiveUserId(true)
      if (user_id) {
        window.clarity("identify", user_id);
      }
    }
    catch (err) {
      console.log("error in user details", err)
    }

  })

  return (
    <ConfigProvider
    // {...config}
    >
      <div className="App">

        <WorkspaceGuard>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Signup />} />
            <Route path="/ig-connect" element={<SignupTwo />} />
            <Route path="/fb-rdr" element={<FbAPIRdr />} />
            <Route path="/fb-api-rdr" element={<FbAPIRdr />} />
            <Route path="/ig_auth_app" element={<IGAUTHAPP />} />
            <Route path="/insta-accounts" element={<InstaAccounts />} />
            <Route path='/' element={<WelcomeOnboardingPage />} />
            <Route path='/fb' element={<FBHome />} />

            <Route path="/ig" element={<HomeV2 />} />
            <Route path="/dashboard" element={<IDMDashboard />} />
            <Route path='/messenger' element={<MessengerPage />} />

            {/* <Route path="/home" element={<Home />} /> */}
            <Route path="/manage-post/:id" element={<Automations />} />
            <Route path="/oia" element={<Oia />} />
            <Route path='/reset-password' element={<ResetPassword />} />
            <Route path="/yt" element={<YT />} />
            <Route path="/inbox-automation" element={<InboxAutomation />} />
            <Route path="/le" element={<LinkExtract />} />
            {/* <Route path="/shop2" element={<Shop/>} /> */}
            <Route path="/shop" element={<SellMain />} />

            <Route path="/shopify" element={<Shopify />} />
            <Route path="/connect-shopify-store" element={<SPConnectAPP />} />
            <Route path="/shopfy-rdr" element={<SPRDR />} />
            <Route path="/shopfy-login" element={<SPLOGIN />} />

            <Route path="/cm" element={<CollectMoney />} />
            <Route path="/flow" element={<FlowComp />} />
            <Route path="/automation-list" element={<AutomationList />} />
            <Route path="/quick-dm" element={<QuickDM />} />
            <Route path="/quick-dm/:id" element={<QuickDM />} />
            <Route path="/referral-dashboard" element={<RefferalList />} />

            <Route path="/linkedin" element={<LinkedIn />} />
            <Route path='/courses' element={<Courses />} />
            <Route path='/digital-products' element={<DigitalProducts />} />
            <Route path='/course/id' element={<CoursePurchaseFlow />} />
            <Route path='/dp/:id' element={<DigitalPurchaseFlow />} />
            <Route path='/msg' element={<MessengerPage />} />
            <Route path='/later' element={<InstagramPostUploader />} />
            <Route path="/c/:id" element={<CollabInvite />} />
            <Route path="/shared-flow/:id" element={<SharedFlowPage />} />
            <Route path="/stripe-success" element={<StripeSuccess />} />
            <Route path="/stripe-failure" element={<StripeFailure />} />

            <Route path="/collab-order-success" element={<StripeSuccess />} />
            <Route path="/collab-order-cancel" element={<StripeFailure />} />

            <Route path="/api-integration" element={<ApiIntegration />} />

            {/* 404 - Catch all unknown routes */}
            <Route path="*" element={<NotFoundPage />} />

            <Route path="/team-settings" element={<TeamSettings />} />
            <Route path="/team-invite/:token" element={<TeamInvite />} />
            <Route path="/workspace-picker" element={<WorkspacePicker />} />

          </Routes>
        </Suspense>
        </WorkspaceGuard>
        <WhatsAppFloat />
      </div>
    </ConfigProvider>
  );
}

export default App;

